/* ==========================================================================
 * bs-btw.js - de btw-schakelaar van het Birdstopper-ontwerp (window.BSBtw)
 * --------------------------------------------------------------------------
 * AFSPRAAK MET DE PAGINABOUWERS
 *   BSBtw.stand()                      'incl' of 'excl'
 *   BSBtw.zet('incl'|'excl')           wisselt, onthoudt (localStorage 'bs_btw'),
 *                                      zet <html data-btw> en stuurt event 'bs:btw'
 *                                      op document met detail { stand }
 *   BSBtw.prijsHtml(centenIncl, opties) dezelfde HTML als snippets/bs-prijs.liquid
 *        opties: { achtervoegsel: true|false (standaard false),
 *                  maat: 'groot'|'normaal'|'klein' (standaard 'normaal') }
 *   BSBtw.exclCenten(centenIncl)       Math.round(centen * 100 / 121), gelijk aan
 *                                      Liquid: bedrag | times: 100.0 | divided_by: 121 | round
 *                                      (een halve cent kan hier niet voorkomen: 200 x centen
 *                                      is even en 121 is oneven, dus Liquid en JS ronden gelijk)
 *   BSBtw.bedrag(centen)               "€ 27,99" (met harde spatie), zoals de money-opmaak
 *
 * Het te betalen bedrag verandert hier nooit: dit is alleen weergave. Beide
 * bedragen staan in de pagina en CSS toont er een (html[data-btw]).
 *
 * Daarnaast: window.BSPalletblok, die de palletblokken (snippets/bs-palletblok)
 * bijwerkt bij een variantwissel. Zie onderaan.
 * ========================================================================== */
(function () {
  'use strict';

  var SLEUTEL = 'bs_btw';
  var TARIEF = 21;

  function lees() {
    try {
      return window.localStorage.getItem(SLEUTEL) === 'excl' ? 'excl' : 'incl';
    } catch (e) {
      return 'incl';
    }
  }

  function stand() {
    return document.documentElement.getAttribute('data-btw') === 'excl' ? 'excl' : 'incl';
  }

  function knoppenBij(s) {
    var knoppen = document.querySelectorAll('[data-bs-btw-zet]');
    for (var i = 0; i < knoppen.length; i++) {
      knoppen[i].setAttribute('aria-pressed', knoppen[i].getAttribute('data-bs-btw-zet') === s ? 'true' : 'false');
    }
  }

  function toepassen(s) {
    document.documentElement.setAttribute('data-btw', s);
    knoppenBij(s);
  }

  function zet(s) {
    s = s === 'excl' ? 'excl' : 'incl';
    var oud = stand();
    try { window.localStorage.setItem(SLEUTEL, s); } catch (e) { /* niet kunnen onthouden: werkt deze pagina toch */ }
    toepassen(s);
    if (oud !== s) {
      document.dispatchEvent(new CustomEvent('bs:btw', { detail: { stand: s } }));
    }
  }

  function exclCenten(centenIncl) {
    return Math.round(Number(centenIncl) * 100 / (100 + TARIEF));
  }

  /* Zelfde uitkomst als {{ centen | money_without_currency }} bij de winkelopmaak
     amount_with_comma_separator: punt voor duizendtallen, komma voor centen. */
  function bedrag(centen) {
    var c = Math.round(Number(centen) || 0);
    var min = c < 0 ? '-' : '';
    c = Math.abs(c);
    var euro = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var cent = String(c % 100);
    if (cent.length < 2) { cent = '0' + cent; }
    return min + '\u20AC\u00A0' + euro + ',' + cent;
  }

  function prijsHtml(centenIncl, opties) {
    opties = opties || {};
    var maat = (opties.maat === 'groot' || opties.maat === 'klein') ? opties.maat : 'normaal';
    var html = '<span class="bs-prijs bs-prijs--' + maat + '">'
      + '<span class="bs-incl">' + bedrag(centenIncl) + '</span>'
      + '<span class="bs-excl">' + bedrag(exclCenten(centenIncl)) + '</span>';
    if (opties.achtervoegsel) {
      html += '<span class="bs-prijs-na"><span class="bs-incl">incl. btw</span><span class="bs-excl">excl. btw</span></span>';
    }
    return html + '</span>';
  }

  document.addEventListener('click', function (e) {
    var knop = e.target && e.target.closest ? e.target.closest('[data-bs-btw-zet]') : null;
    if (!knop) { return; }
    e.preventDefault();
    zet(knop.getAttribute('data-bs-btw-zet'));
  });

  function gelijk() { toepassen(lees()); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gelijk);
  } else {
    gelijk();
  }
  document.addEventListener('shopify:section:load', gelijk);
  window.addEventListener('pageshow', gelijk);
  window.addEventListener('storage', function (e) {
    if (e.key === SLEUTEL) {
      var oud = stand();
      gelijk();
      if (oud !== stand()) {
        document.dispatchEvent(new CustomEvent('bs:btw', { detail: { stand: stand() } }));
      }
    }
  });

  window.BSBtw = {
    stand: stand,
    zet: zet,
    prijsHtml: prijsHtml,
    exclCenten: exclCenten,
    bedrag: bedrag
  };

  /* ------------------------------------------------------------------------
   * BSPalletblok: werkt elk [data-bs-palletblok] bij voor een andere variant.
   *   BSPalletblok.zet(variantId)            alle blokken op de pagina
   *   BSPalletblok.zet(variantId, blokEl)    alleen dat blok
   * Of stuur: document.dispatchEvent(new CustomEvent('bs:variant', { detail: { id: 123 } }))
   * Refresh-variantwissels (pubsub variant-change) worden ook opgepikt.
   * Er wordt hier niet met geld gerekend, alleen met rollen.
   * ---------------------------------------------------------------------- */
  function rollenWoord(n) { return n === 1 ? '1 rol' : n + ' rollen'; }

  function blokZet(blok, variantId) {
    var bron = blok.querySelector('script[data-bs-palletblok-varianten]');
    if (!bron) { return false; }
    var lijst;
    try { lijst = JSON.parse(bron.textContent || '{}'); } catch (e) { return false; }
    var v = lijst[String(variantId)];
    if (!v || !(v.rollen > 0) || !(v.rollen_per_pallet > 0)) {
      blok.hidden = true;
      return false;
    }
    var keer = Math.ceil(v.rollen_per_pallet / v.rollen);
    var pct = Math.min(100, Math.round(v.rollen / v.rollen_per_pallet * 1000) / 10);

    blok.hidden = false;
    blok.setAttribute('data-variant-id', String(variantId));
    blok.setAttribute('data-rollen', String(v.rollen));
    blok.setAttribute('data-rollen-per-pallet', String(v.rollen_per_pallet));
    blok.setAttribute('data-diameter', String(v.diameter));
    blok.setAttribute('data-keer', String(keer));

    function vul(sel, tekst) {
      var els = blok.querySelectorAll('[data-bs-pb="' + sel + '"]');
      for (var i = 0; i < els.length; i++) { els[i].textContent = tekst; }
    }
    vul('rollen', rollenWoord(v.rollen));
    vul('diameter', String(v.diameter));
    vul('per-pallet', rollenWoord(v.rollen_per_pallet));
    vul('keer', keer + 'x dit artikel');
    vul('links', '1 stuk: ' + v.rollen + ' van ' + v.rollen_per_pallet + ' rollen');
    vul('rechts', keer + ' stuks: 5% korting');
    var balk = blok.querySelector('[data-bs-pb="balk"]');
    if (balk) { balk.style.width = pct + '%'; }
    return true;
  }

  function palletZet(variantId, blokEl) {
    var blokken = blokEl ? [blokEl] : document.querySelectorAll('[data-bs-palletblok]');
    for (var i = 0; i < blokken.length; i++) { blokZet(blokken[i], variantId); }
  }

  document.addEventListener('bs:variant', function (e) {
    if (e.detail && e.detail.id) { palletZet(e.detail.id); }
  });

  function aanPubsub() {
    /* PUB_SUB_EVENTS is in constants.js een const: geen window-eigenschap, wel globaal bereikbaar. */
    var events = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : null; // eslint-disable-line no-undef
    if (typeof window.subscribe === 'function' && events && events.variantChange) {
      window.subscribe(events.variantChange, function (evt) {
        var v = evt && evt.data && evt.data.variant;
        if (v && v.id) { palletZet(v.id); }
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', aanPubsub);
  } else {
    aanPubsub();
  }

  window.BSPalletblok = { zet: palletZet };
})();
